export { default } from './part-review-card';
